import { appGraphemeMeaningCardTable } from "@-/dev.improve.haniverse.database.schemas.content.schema._tables.app-grapheme-meaning-card";
import { contentTable, index, integer, text } from "@-/dev.improve.haniverse.lib.database.table";

export const appGraphemeMeaningCardAliasTable = contentTable(
  "app_grapheme_meaning_card_alias",
  {
    alias: text("alias").notNull(),
    appGraphemeMeaningCardId: integer("app_grapheme_meaning_card_id")
      .notNull()
      .references(() => appGraphemeMeaningCardTable.id),
    /**
     * The alias's position in the grapheme file's authored `component.mnemonic` list; the first is
     * the primary mnemonic. Order by THIS, never by `id`: ids come from sorted row keys, so id
     * order is alphabetical and shifts whenever an alias is added.
     */
    position: integer("position").notNull().default(0),
  },
  // Backs the `appGraphemeMeaningCard.aliases` relation join.
  (table) => [
    index("app_grapheme_meaning_card_alias_meaning_card_id_idx").on(table.appGraphemeMeaningCardId),
  ],
);

export type AppGraphemeMeaningCardAlias = typeof appGraphemeMeaningCardAliasTable.$inferSelect;
